import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { WebSocketProvider } from "./context/WebSocketContext";
import { Layout } from "./components/layout/Layout";
import { ModeratorLayout } from "./components/layout/ModeratorLayout";
import ConnectionStatus from "./components/common/ConnectionStatus";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Sites from "./pages/Sites";
import Chargers from "./pages/Chargers";
import ChargerDetail from "./pages/ChargerDetail";
import ChargerEdit from "./pages/ChargerEdit";
import Users from "./pages/Users";
import StaffUsers from "./pages/StaffUsers";
import Clients from "./pages/Clients";
import Moderators from "./pages/Moderators";
import ModeratorDetail from "./pages/ModeratorDetail";
import Sessions from "./pages/Sessions";
import Analytics from "./pages/Analytics";
import CashTopup from "./pages/CashTopup";
import AuditLogs from "./pages/AuditLogs";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import PaymentProcessors from "./pages/PaymentProcessors";
import PushNotifications from "./pages/PushNotifications";
import Wallet from "./pages/Wallet";
import Invoices from "./pages/Invoices";
import FiscalInvoices from "./pages/FiscalInvoices";
import RFIDCards from "./pages/RFIDCards";
import Notifications from "./pages/Notifications";
import ClientDetail from "./pages/moderator/ClientDetail";
import OCPPLogs from "./pages/OCPPLogs";
import Backup from "./pages/Backup";
import ChangePassword from "./pages/ChangePassword";
import { Toaster } from "./components/ui/sonner";
import AdminBusinesses from "./pages/AdminBusinesses";
import BusinessDetail from "./pages/BusinessDetail";
import LiveStatusBoard from "./pages/LiveStatusBoard";
import ManualCharge from "./pages/ManualCharge";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <WebSocketProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              
              {/* Admin Routes — requires login (Layout redirects to /login) */}
              <Route path="/" element={<Layout />}>
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="sites" element={<Sites />} />
                <Route path="chargers" element={<Chargers />} />
                <Route path="chargers/:id" element={<ChargerDetail />} />
                <Route path="chargers/:id/edit" element={<ChargerEdit />} />
                <Route path="live" element={<LiveStatusBoard />} />
                {/* Staff & Clients (new separated routes) */}
                <Route path="staff" element={<StaffUsers />} />
                <Route path="clients" element={<Clients />} />
                <Route path="clients/:id" element={<ClientDetail />} />
                {/* Legacy routes */}
                <Route path="users" element={<Users />} />
                <Route path="moderators" element={<Moderators />} />
                <Route path="moderators/:id" element={<ModeratorDetail />} />
                <Route path="sessions" element={<Sessions />} />
                <Route path="analytics" element={<Analytics />} />
                <Route path="cash-topup" element={<CashTopup />} />
                <Route path="manual-charge" element={<ManualCharge />} />
                <Route path="wallets" element={<Wallet />} />
                <Route path="wallet" element={<Wallet />} />
                <Route path="invoices" element={<Invoices />} />
                <Route path="fiscal-invoices" element={<FiscalInvoices />} />
                <Route path="rfid-cards" element={<RFIDCards />} />
                <Route path="reports" element={<Reports />} />
                <Route path="notifications" element={<Notifications />} />
                <Route path="audit-logs" element={<AuditLogs />} />
                <Route path="settings" element={<Settings />} />
                <Route path="settings/:tab" element={<Settings />} />
                <Route path="backup" element={<Backup />} />
                <Route path="payment-processors" element={<PaymentProcessors />} />
                <Route path="push-notifications" element={<PushNotifications />} />
                <Route path="ocpp-logs" element={<OCPPLogs />} />
                <Route path="admin-businesses" element={<AdminBusinesses />} />
                                <Route path="admin-businesses/:id" element={<BusinessDetail />} />
                <Route path="change-password" element={<ChangePassword />} />
              </Route>

              {/* Legacy moderator-prefixed URLs redirect to unified routes */}
              <Route path="/moderator/*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
            <ConnectionStatus />
            <Toaster richColors position="top-right" />
          </BrowserRouter>
        </WebSocketProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
